import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button } from "../";
import { Link } from "react-router-dom";

var dialog = function dialog(props) {
  var fullScreen = props.fullScreen,
      dialogPaper = props.dialogPaper;
  var open = props.open;
  var fullWidth = props.fullWidth;
  var maxWidth = props.maxWidth || "sm";
  var buttonCancel = props.onCancel ? /*#__PURE__*/React.createElement(Button, {
    "data-cy": "cancel",
    onClick: props.onCancel,
    color: props.buttonColorCancel,
    variant: props.buttonVariantCancel
  }, props.cancel) : null;
  var buttonSuccess = props.onSubmit ? /*#__PURE__*/React.createElement(Button, {
    "data-cy": "submit",
    onClick: props.onSubmit,
    color: props.buttonColorSubmit,
    variant: props.buttonVariantSubmit
  }, props.submit) : null;

  if (props.successLink) {
    buttonSuccess = /*#__PURE__*/React.createElement(Button, {
      component: Link,
      to: props.successLink,
      color: props.buttonColorSubmit,
      variant: props.buttonVariantSubmit
    }, props.submit);
  }

  return /*#__PURE__*/React.createElement(Dialog, {
    fullScreen: fullScreen,
    fullWidth: fullWidth,
    maxWidth: maxWidth,
    open: open,
    onClose: props.onClose,
    "aria-labelledby": props.id,
    classes: {
      paper: props.dialogPaper || null
    },
    height: "40%"
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: props.id
  }, props.title), /*#__PURE__*/React.createElement(DialogContent, null, props.text && /*#__PURE__*/React.createElement(DialogContentText, null, props.text), props.children), /*#__PURE__*/React.createElement(DialogActions, null, buttonCancel, buttonSuccess));
};

export default dialog;